// Shared by React Native controls and the Windows selectable transcript.
export const SCROLL_TO_BOTTOM = { size: 32, icon: 16, inset: 12, border: 1 };
export const scrollToBottomColors = colors => ({
  backgroundColor: colors.scrollBackground || colors.canvas,
  borderColor: colors.scrollBorder || colors.edge || colors.border,
});
export const scrollToBottomStyle = {
  height: SCROLL_TO_BOTTOM.size, minHeight: SCROLL_TO_BOTTOM.size,
  borderWidth: SCROLL_TO_BOTTOM.border, shadowOpacity: 0, elevation: 0,
};
